const prefix = 'salesforce-link-button';

export const i18n = {
    navigateToSalesforce: {
        id: `${prefix}.navigateToSalesforce`,
        defaultMessage: 'Navigate to Salesforce',
    },
} as const;
